import { render } from "./RoundLeaderboard.vue?vue&type=template&id=45fc2f72&scoped=true"
import script from "./RoundLeaderboard.vue?vue&type=script&lang=js"
export * from "./RoundLeaderboard.vue?vue&type=script&lang=js"

import "./RoundLeaderboard.vue?vue&type=style&index=0&id=45fc2f72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fc2f72"]])

export default __exports__